import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_ScrollBar } from '@app/styles/frontend/modules/ModuleFE_ScrollBar/ModuleFE_ScrollBar';
import { ICONS } from '@app/styles';
import { AdvisorWizardTree_SnippetRenderer } from './snippet-renderer.js';
import { AdvisorWizardTree_VariableRenderer } from './variable-renderer.js';
import { AdvisorWizardTree_ValueRenderer } from './value-renderer.js';
import { AdvisorWizardTree_AttributeRenderer } from './attribute-renderer.js';
export const AdvisorWizardTree_NodeRenderer = (props, adapter, scrollRef) => {
    const type = props.item.type;
    const Renderer = adapter.resolveRenderer(type);
    const className = _className('tree-node-container', type);
    // @ts-ignore - _isParent does exist on item
    const hasChildren = !!props.item._isParent;
    return _jsxs(LL_H_C, { className: className, onClick: e => {
            props.node.expandToggler(e);
            //Update the scrollbar whenever the expansion of the tree is changed
            setTimeout(() => ModuleFE_ScrollBar.updateScrollBar(scrollRef));
        }, children: [_jsx(ICONS.advisor_v4_arrow.component, { className: _className('tree-expand-icon', props.node.expanded && 'open', !hasChildren && 'hidden') }), _jsx(Renderer, { item: props.item.item, node: props.node })] });
};
export const AdvisorWizardTree_Renderers = (treeExpansionState) => ({
    root: () => _jsx(_Fragment, {}),
    snippet: props => AdvisorWizardTree_SnippetRenderer(props, treeExpansionState),
    variable: props => AdvisorWizardTree_VariableRenderer(props),
    value: props => AdvisorWizardTree_ValueRenderer(props),
    attribute: props => AdvisorWizardTree_AttributeRenderer(props),
    'precipitating-factor': props => AdvisorWizardTree_AttributeRenderer(props),
    'relieving-factor': props => AdvisorWizardTree_AttributeRenderer(props),
    attributeValue: () => _jsx(_Fragment, {}),
    'variable-selector': () => _jsx(_Fragment, {}),
    'relieving-factors-group': () => _jsx("div", { className: 'tree-data group-title', children: "Relieving Factors" }),
    'precipitating-factors-group': () => _jsx("div", { className: 'tree-data group-title', children: "Precipitating Factors" }),
});
//# sourceMappingURL=utils.js.map